import * as React from 'react';

export interface IntersectionContextValues {
    handleRef: ((onObserve: () => void) => (element: HTMLElement | null) => void) | null;
}

export const IntersectionContext = React.createContext<IntersectionContextValues>({
    handleRef: null,
});

export function useIntersection(): IntersectionContextValues {
    return React.useContext(IntersectionContext);
}
